import React, { useState } from 'react'
import { CDN_URL } from '../../constants/siteConstant'
import { useTranslation } from 'react-i18next'
import { Card, CardContent } from '../ui/card'
import { Label } from '../ui/label'
import { Input } from '../ui/input'
import { Button } from '../ui/button'
import { goToHomePage } from 'src/helpers/Utils'

const errorStyle = {
  fontSize: '12px',
  color: 'red',
  marginTop: '4px'
}

export default function ViewRequestActiveStep1 ({
  formData,
  handleChange,
  handleSubmit
}) {
  const { t } = useTranslation(['viewRequest'])
  const [showPassword, setShowPassword] = useState(false)

  const togglePassword = () => {
    setShowPassword(!showPassword)
  }

  return (
    <div className='login-container'>
      <div className='logo' onClick={goToHomePage} />
      <Card className='login-card p-8'>
        <div
          className='login-left flex-center flex-d-column'
          style={{
            backgroundImage: `url('${CDN_URL}/workshop-portal/static-images/login-bg.svg')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: 'auto'
          }}
        >
          <div className='font-weight-700 gp-text24 text-white tracking-0 gp-lh28 gp-mb20'>
            {t('pageTitle')}
          </div>
          <p>
            {t('pageSubtitle')}
          </p>
        </div>
        <CardContent
          style={{
            height: 'auto',
            paddingRight: '0px'
          }}
          className='login-right'
        >
          <h2 className='font-weight-700 gp-text24 tracking-0 gp-lh28 gp-mb8'>
            {t('createAccount')}
          </h2>
          <p className='subheading'>
            {t('createAccountSubheanding')}
          </p>

          <div className='form-group gp-mb16'>
            <Label htmlFor='email' className='gp-mb8 required'>
              {t('emailAddress')}
            </Label>
            <Input
              name='email'
              value={formData.email}
              onChange={handleChange}
              disabled
              id='email'
              type='email'
              placeholder='Your email address'
            />
            <span style={errorStyle}>{formData.emailError || ''}</span>
          </div>

          <div className='form-group gp-mb16'>
            <Label htmlFor='firstName' className='gp-mb8 required'>
              {t('firstName')}
            </Label>
            <Input
              name='firstName'
              value={formData.firstName}
              onChange={handleChange}
              style={{
                borderColor: formData.firstNameError ? 'red' : '#EBEAED',
                fontSize: '12px'
              }}
              id='firstName'
              placeholder='Max'
            />
            <span style={errorStyle}>{formData.firstNameError || ''}</span>
          </div>

          <div className='form-group gp-mb16'>
            <Label htmlFor='lastName' className='gp-mb8 required'>
              {t('lastName')}
            </Label>
            <Input
              name='lastName'
              value={formData.lastName}
              onChange={handleChange}
              disableUnderline
              placeholder='Mustermann'
              id='lastName'
            />
          </div>

          <div className='form-group'>
            <Label htmlFor='password' className='gp-mb8 required'>
              {t('password')}
            </Label>
            <div className='password-wrapper'>
              <Input
                value={formData.password}
                onChange={handleChange}
                style={{
                  borderColor: formData.passwordError ? 'red' : '#EBEAED'
                }}
                id='password'
                name='password'
                type={showPassword ? 'text' : 'password'}
                placeholder='*************'
                // onKeyPress={handleKeyPress}
              />
              <span style={errorStyle}>{formData.passwordError || ''}</span>
              <img
                src={
                  showPassword
                    ? `${CDN_URL}/workshop-portal/icons/eye-thin.svg`
                    : `${CDN_URL}/workshop-portal/icons/eye-close-thin.svg`
                }
                onClick={togglePassword}
                alt='Toggle visibility'
                className='toggle-password-icon'
              />
            </div>
          </div>

          <Button className='login-button bg-[#6926D9]' onClick={handleSubmit}>
            {t('createAccount')}
          </Button>

          <p className='password-reset'>
            {t('agreeTermsCondition')}
            <a
              href='https://goparts.tech/privacy-policy'
              target='_blank'
              rel='noreferrer'
            >
              {' '}
              {t('privacyPolicy')}
            </a>{' '}
            {t('andThe')}
            <a
              href='https://goparts.tech/terms-and-conditions'
              target='_blank'
              rel='noreferrer'
            >
              {' '}
              {t('termsAndConditions')}
            </a>{' '}
            zu.
          </p>
        </CardContent>
      </Card>
    </div>
  )
}
